import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import 'es6-promise/auto';

import Router from 'aa/vue/Router';
import Store from 'aa/vue/stores/Store';

import SentryForVue from 'aa/services/SentryForVue'
import Funnel from 'aa/vue/components/Funnel';
import SvodHeader from 'aa/vue/components/SvodHeader';
import ShowtimeBundle from 'aa/vue/components/ShowtimeBundle';
import Debug from 'aa/vue/components/Debug';
import HttpService from 'services/HttpService';
import ShowsPickerService from 'services/ShowsPickerService';
import ProfileService from 'services/ProfileService';
import PurchaseFunnelGlobal from 'aa/vue/plugins/purchaseFunnel/PurchaseFunnelGlobal';
import localeBundlePlugin from 'plugins/localeBundle';
import { getBundleFromJSON } from 'services/LocalizationService';
import Sanitizer from 'apps/plugins/Sanitizer';
import BaseModalWrapper from 'aa/vue/atoms/BaseModalWrapper';

// CBSCOMSUB-4696
import NotificationBar from 'aa/vue/components/NotificationBar';

export function initApp(routerConfig = {}) {
    if (CBS.Registry.Features.braze_sdk === true) {
        import('shared/Braze').then((Braze) => {
            new Braze.default();
        });
    }

    Vue.config.productionTip = false;

    Vue.use(VueRouter);
    Vue.use(Vuex);
    Vue.use(PurchaseFunnelGlobal);
    Vue.use(Sanitizer);
    Vue.use(localeBundlePlugin);

    let serverData = JSON.parse(
        document.getElementById('app-config').innerHTML
    );
    const store = Store();

    routerConfig.store = store;

    const http = new HttpService();
    const localeBundle = getBundleFromJSON();
    store.$http = http;
    Vue.prototype.$http = http;

    routerConfig.store = store;
    routerConfig.regionBaseUrl = serverData.regionBaseUrl;
    const router = Router(routerConfig);

    store.$spicker_service = new ShowsPickerService();
    store.$profile_service = new ProfileService();

    const app = new Vue({
        name: 'App',
        router,
        store,
        data: {
            serverData: serverData,
            debug: false
        },
        beforeCreate: function () {
            if (serverData.recurlyPublicKey) {
                store.dispatch('payment/insertRecurlyScript', serverData);
            }
        },
        created: function () {
            store.commit('setImageHost', this.serverData.imageHost);
            store.commit(
                'tracking/setIntcid',
                encodeURIComponent(this.$route.query.intcid)
            );
            store.commit('setToken', this.serverData.tk_trp);
            store.commit(
                'partner/setPartnerAuthAttributes',
                serverData?.partnerAuthAttributes
            );
            store.commit('setLocaleDictionary', localeBundle);
            const selectedPlan = JSON.parse(
                localStorage.getItem('selectedPlan')
            );
            if (selectedPlan) {
                store.dispatch('plan/setSelectedPlan', selectedPlan);
                store.dispatch('plan/setPlanType', {
                    planType: selectedPlan.planType
                });
            }

            let promo = null;

            if (this.serverData.promo !== null || this.$route.query.promo) {
                promo =
                    this.serverData.promo || this.$route.query.promo || null;
                promo = promo ? encodeURIComponent(promo) : null;
            }

            store.commit('setFeatureFlags', this.serverData?.featureFlag)
            store.dispatch('updateCoupon', promo);
        },
        mounted: function () {
            window.addEventListener('load', (event) => {
                store.dispatch('variant/setVariantFromUrl');
              });
        },
        components: {
            Funnel,
            BaseModalWrapper,
            ShowtimeBundle
        }
    }).$mount('#app');

    SentryForVue(app)
}
